import { useQuery, QueryFunction } from 'react-query';
import {
    getAllTrucks,
    GetAllTrucksQueries,
    getSiteTrucksSupervisionByDate,
    getTrucksByCompanyId,
    getTrucksSupervisionByDate,
    SiteSupervision,
    SiteTruckSupervision,
    Truck,
    TruckSupervision,
} from '../../services/apiSLTP/materials/trucks';

type UseTrucksQueryOptions = {
    queries?: GetAllTrucksQueries;
};

const getTrucks: QueryFunction<Truck[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTrucksQueryOptions];
    const { queries } = options;

    const response = await getAllTrucks(queries);
    return response.data;
};

export const useTrucksQuery = (options: UseTrucksQueryOptions) => {
    return useQuery(['trucks', options], getTrucks);
};

type UseTruckByCompanyQueryOptions = { truckCompanyId: string };

const getTrucksByCompany: QueryFunction<Truck[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTruckByCompanyQueryOptions];
    const { truckCompanyId } = options;

    const response = await getTrucksByCompanyId(truckCompanyId);
    return response.data;
};

export const useTruckByCompanyQuery = (options: UseTruckByCompanyQueryOptions) => {
    return useQuery(['trucks by company', options], getTrucksByCompany);
};

type UseTrucksSupervisionQueryOptions = {
    date: string;
};

const getTrucksSupervision: QueryFunction<TruckSupervision[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTrucksSupervisionQueryOptions];
    const { date } = options;

    const response = await getTrucksSupervisionByDate(date);
    return response.data;
};

export const useTrucksSupervisionQuery = (options: UseTrucksSupervisionQueryOptions) => {
    return useQuery(['trucks supervision', options], getTrucksSupervision, {
        refetchInterval: 300000,
        staleTime: 10000,
    });
};

type UseSitesTrucksSupervisionQueryOptions = {
    date: string;
};

const getSitesTrucksSupervision: QueryFunction<SiteSupervision[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSitesTrucksSupervisionQueryOptions];
    const { date } = options;

    const response = await getSiteTrucksSupervisionByDate(date);
    return response.data;
};

export const useSitesTrucksSupervisionQuery = (options: UseSitesTrucksSupervisionQueryOptions) => {
    return useQuery(['sites trucks supervision', options], getSitesTrucksSupervision, {
        refetchInterval: 300000,
        staleTime: 10000,
    });
};
